
<style scoped lang='stylus'>
.bridge-page
  background-color white
  padding-top 30px
  text-align center
  height 100vh
</style>
<template>
  <div class="bridge-page">
    加载中....
  </div>
</template>
<script>
import { getLocationQuery } from '../../../common/utils'
import jsCookies from 'js-cookie';

export default {
  name: 'app-wechat-bridge',
  components: {},
  mixins: [],
  props: {
    // name: { type: Array, default: () => [] }
  },
  data: function () {
    return {
      flowData: []
    }
  },
  computed: {},
  created: function () {
    /**
     * 写入非referUrl的query到cookie
     */

    //  获取数据
    const { url, refer, referrer, ...cookies } = getLocationQuery()
    // eslint-disable-next-line no-useless-escape
    const host = location.hostname.match(/(\..+$)|(^[^\.]*$)/)[0] // .cekid.com

    // alert(JSON.stringify(cookies));
    // 写入cookie

    let topDomain = location.hostname;

    const parts = location.host.split('.');
    if (parts.length >= 2) {
        // 取最后两部分作为根域名（例如 "example.com"）
        topDomain = parts.slice(-2).join('.');
    };

    Object.keys(cookies).forEach(key => {
      // document.cookie = `${key}=${decodeURIComponent(cookies[key])}; domain=${host}; path=/`
      jsCookies.set(key, decodeURIComponent(cookies[key]), {
        domain: '.' + topDomain, 
      })
    })
    const token = jsCookies.get('token')
    // 跳转refer
    const referUrl = url || refer || referrer

    // debugger
    referUrl && location.replace(decodeURIComponent(referUrl))
  },
  mounted: function () {},
  watch: {},
  methods: {},
}
</script>
